import React from 'react'
import ReactDOM from 'react-dom/client'
import { MotionConfig } from 'framer-motion'
import App from './App'
import Admin from './Admin'
import './index.css'

const isAdmin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MotionConfig reducedMotion="user">{isAdmin ? <Admin /> : <App />}</MotionConfig>
  </React.StrictMode>
)
